import { render, staticRenderFns } from "./EcommerceLinksManager.vue?vue&type=template&id=6082ff64&scoped=true"
import script from "./EcommerceLinksManager.vue?vue&type=script&lang=js"
export * from "./EcommerceLinksManager.vue?vue&type=script&lang=js"
import style0 from "./EcommerceLinksManager.vue?vue&type=style&index=0&id=6082ff64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6082ff64",
  null
  
)

export default component.exports